import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/hooks/useAuth";
import RequireTerms from "@/components/RequireTerms";
import CookieConsent from "@/components/CookieConsent";
import SeoHead from "@/components/SeoHead";
import AdminBetaPreviewIndicator from "@/components/AdminBetaPreviewIndicator";
import Index from "./pages/Index.tsx";
import Auth from "./pages/Auth.tsx";
import Dashboard from "./pages/Dashboard.tsx";
import NewInvoice from "./pages/NewInvoice.tsx";
import InvoiceDetail from "./pages/InvoiceDetail.tsx";
import EditInvoice from "./pages/EditInvoice.tsx";
import Settings from "./pages/Settings.tsx";
import SelectPlan from "./pages/SelectPlan.tsx";
import Admin from "./pages/Admin.tsx";

import ResetPassword from "./pages/ResetPassword.tsx";
import AcceptTerms from "./pages/AcceptTerms.tsx";
import Terms from "./pages/Terms.tsx";
import Privacy from "./pages/Privacy.tsx";
import Contact from "./pages/Contact.tsx";
import NotFound from "./pages/NotFound.tsx";
import Unsubscribe from "./pages/Unsubscribe.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
      <AuthProvider>
        <TooltipProvider delayDuration={300}>
          <SeoHead />
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/dashboard" element={<RequireTerms><Dashboard /></RequireTerms>} />
              <Route path="/select-plan" element={<RequireTerms><SelectPlan /></RequireTerms>} />
              <Route path="/invoice/new" element={<RequireTerms><NewInvoice /></RequireTerms>} />
              <Route path="/invoice/:id" element={<RequireTerms><InvoiceDetail /></RequireTerms>} />
              <Route path="/invoice/:id/edit" element={<RequireTerms><EditInvoice /></RequireTerms>} />
              <Route path="/settings" element={<RequireTerms><Settings /></RequireTerms>} />
              <Route path="/admin" element={<RequireTerms><Admin /></RequireTerms>} />
              
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/accept-terms" element={<AcceptTerms />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
            <CookieConsent />
            <AdminBetaPreviewIndicator />
          </BrowserRouter>
        </TooltipProvider>
      </AuthProvider>
    </ThemeProvider>
  </QueryClientProvider>
);

export default App;
